import { FC } from 'react';

import { AboutUsSubpageFactsFragment_PublisherAboutUsFacts_Fragment } from '../../graphql/fragment/about-us-subpage-facts-fragment.gql-types';

import type { CommonFactsItem } from './create-facts-item';
import { createFactsItemFoundingYear } from './create-facts-item';
import { Facts } from './facts';

type FactsPublisherProps = {
  facts: AboutUsSubpageFactsFragment_PublisherAboutUsFacts_Fragment;
};
export const FactsPublisher: FC<FactsPublisherProps> = ({ facts }) => {
  const items: CommonFactsItem[] = [];
  const categories: string[] = [];

  if (facts.foundingYear) {
    items.push(createFactsItemFoundingYear(facts.foundingYear));
  }

  return (
    <Facts
      headlineKey="EP_COMPANY_SUMMARY"
      items={items}
      categoriesHeadlineKey="EP_COMPANY_INDUSTRY"
      categories={categories}
      facts={facts}
    />
  );
};
